/* eslint-disable no-undef */
import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import GoEasy from 'goeasy'
import GRTC from 'goeasy-rtc'
const vm = createApp(App);

// 即时通信
GoEasy.getInstance({
	host: 'hangzhou.goeasy.io', //若是新加坡区域：singapore.goeasy.io
	appkey: 'BC-43a0ee269ffa4369a67711cd8a2f5a7e',
	modules: ['im'], //根据需要，传入'im’或‘pubsub’，或数组方式同时传入
});
// 客服
GoEasy.getInstance({
	host: 'hangzhou.goeasy.io', //若是新加坡区域：singapore.goeasy.io
	appkey: 'BC-43a0ee269ffa4369a67711cd8a2f5a7e',
	modules: ['pubsub'], //根据需要，传入'im’或‘pubsub’，或数组方式同时传入
});
GRTC.init(GoEasy);
window.GRTC = GRTC;


vm.config.globalProperties.GoEasy = GoEasy;
vm.config.globalProperties.GRTC = GRTC;
// vm.prototype.GoEasy = GoEasy;


// 全局指令 v-mathml，使用 WIRIS 解析（解析公式渲染显示）
vm.directive('mathml', {
  mounted(el) {
    if (window.com?.wiris?.js?.JsPluginViewer) {
      com.wiris.js.JsPluginViewer.parseElement(el, true, function() {
        console.log('WIRIS解析完成', el)
      })
    }
  },
  updated(el) {
    if (window.com?.wiris?.js?.JsPluginViewer) {
      com.wiris.js.JsPluginViewer.parseElement(el, true, function() {
        console.log('WIRIS解析完成', el)
      })
    }
  }
})

/** 引入动画库 */
import 'animate.css/animate.min.css'

/** 引入vue-videp-play插件 */
import VueVideoPlayer from 'vue-video-player'
// require videojs style
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
vm.use(VueVideoPlayer)

// 签名（画布）
// import VueSignaturePad from "vue-signature-pad";
// vm.use(VueSignaturePad);

/** 全局引入UI库 */
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
vm.use(ElementPlus);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  vm.component(key, component)
}

// 引入连线方法
import jsPlumb from 'jsplumb';
vm.config.globalProperties.$jsPlumb = jsPlumb;

// 引入第三方类库
import Moment from 'moment'
vm.config.globalProperties.$Moment = Moment

// 引入自定义类库
import * as Config from './config/config'
vm.config.globalProperties.$Config = Config;
import Auth from './assets/utils/auth'
vm.config.globalProperties.$Auth = Auth;
import * as Jump from './assets/utils/jump'
vm.config.globalProperties.$Jump = Jump;
import * as Tree from './assets/utils/tree'
vm.config.globalProperties.$Tree = Tree;
import * as Tools from './assets/utils/tools'
vm.config.globalProperties.$Tools = Tools;
import * as Cache from './assets/utils/cache'
vm.config.globalProperties.$Cache = Cache;
import * as Dialog from './assets/utils/dialog'
vm.config.globalProperties.$Dialog = Dialog;
import * as Validator from './assets/utils/validator'
vm.config.globalProperties.$Validator = Validator;
import * as Api from './api/api'
vm.config.globalProperties.$Api = Api;
// import Loading from './components/moeCommon/loading'
// vm.config.globalProperties.$Loading = Loading;
// 引入防抖节流函数文件
import { debounce, throttle } from './assets/utils/dbucTrtl.js';
// 在Vue实例上扩展全局方法
vm.config.globalProperties.$debounce = debounce;
vm.config.globalProperties.$throttle = throttle;

// 引入事件总线
import emitter from './utils/emitter.js';
vm.config.globalProperties.$emitter = emitter;


// 公共组件
import MoeTop from "@/components/moeCommon/moeTop";
vm.component('moeTop', MoeTop);
import MoeBottom from "@/components/moeCommon/moeBottom";
vm.component('moeBottom', MoeBottom);
import MoeRight from "@/components/moeCommon/moeRight";
vm.component('moeRight', MoeRight);
import MoePage from "@/components/moeCommon/moePage";
vm.component('moePage', MoePage);
import MoeTooltip from "@/components/moeCommon/moeTooltip";
vm.component('MoeTooltip', MoeTooltip);
import videomuiPlayer from '@/components/video/videomuiPlayer';
vm.component('videomuiPlayer', videomuiPlayer);
import MoeEmpty from "@/components/moeCommon/moeEmpty";
vm.component('MoeEmpty', MoeEmpty);

// 全局混入 Common
import mixinCommon from './mixins/common'
vm.mixin(mixinCommon);

// 版本号更新，清空缓存
let version = '102';
if (Tools.empty(Cache.get('version')) || Cache.get('version') !== version) {
  Cache.clear();
  Cache.set('version', version);
}

// // 全局引入goeasy
// vm.config.globalProperties.goeasy = GoEasy.getInstance({
//     host:"hangzhou.goeasy.io",  //若是新加坡区域：singapore.goeasy.io
//     appkey:"BC-91287a67ca0444ba94dab7d8a12c6b8d",
//     modules:['im']//根据需要，传入'im’或'pubsub'，或数组方式同时传入
// });

vm.use(router).use(store).mount('#app');